// removed by extract-text-webpack-plugin
module.exports = {"ImageModal":"ImageModal__-loca-__1r55B"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/ImageModal/ImageModal.css
// module id = 130
// module chunks = 0